import styled from 'styled-components';
import { ImageSectionStyled } from '../ImageSectionStyled';
import { rem } from 'polished';

export const ImageSectionStyledAC = styled(ImageSectionStyled)`
    .react-multiple-carousel__arrow {
        border-width: 2px;
        border-radius: 10px;
        border-color: ${({ theme }) => theme.colors.red};

        &:hover,
        &:focus-visible {
            border-color: ${({ theme }) => theme.colors.grey5};
            background: ${({ theme }) => theme.colors.white};

            &::before {
                color: ${({ theme }) => theme.colors.grey5};
            }
        }

        &::before {
            color: ${({ theme }) => theme.colors.red};
        }
    }

    .dealer {
        .address {
            color: ${({ theme }) => theme.colors.black};
        }
    }

    .delivery {
        background: ${({ theme }) => theme.colors.grey6};
        color: ${({ theme }) => theme.colors.grey5};
    }

    .redirectLink {
        font-size: ${({ theme }) => theme.fontSizes.h4};

        span {
            &:hover {
                color: ${({ theme }) => theme.colors.red};
                border-color: ${({ theme }) => theme.colors.red};
            }
        }
    }
`;
